<template>
  <b-card :title="title" class="border-0">
    <submission-review-card
      v-for="(submission, k) in project.submissions"
      :key="k"
      :submission="submission"
      :managedLists="managedLists"
    />
  </b-card>
</template>

<script>
import CustomerModel from "@/models/crm/CustomerModel";
import CustomerContactModel from "@/models/crm/CustomerContactModel";
import CustomerLocationModel from "@/models/crm/CustomerLocationModel";
import SubmissionReviewCard from "./SubmissionReviewCard.vue";

export default {
  components: { SubmissionReviewCard },
  name: "ProjectReviewCard",
  props: {
    project: {
      type: Object,
      default: () => null,
    },
    managedLists: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      customer: null,
      customer_contact: null,
      customer_location: null,
    };
  },
  computed: {
    title() {
      return (
        [
          this.customer ? this.customer.short_name : null,
          this.customer_contact ? this.customer_contact.fullName() : null,
        ]
          .filter((i) => i)
          .join(" - ") || null
      );
    },
  },
  watch: {
    "project.customer_id": {
      handler(id) {
        let entity = new CustomerModel({ id });

        entity.fetch().then(() => {
          this.customer = entity;
        });
      },
      immediate: true,
      deep: true,
    },
    "project.customer_contact_id": {
      handler(id) {
        let entity = new CustomerContactModel({ id });

        entity.fetch().then(() => {
          this.customer_contact = entity;
        });
      },
      immediate: true,
      deep: true,
    },
    "project.customer_location_id": {
      handler(id) {
        if (id) {
          let entity = new CustomerLocationModel({ id });
          
          entity.fetch().then(() => {
            this.customer_location = entity;
          });
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>
